export const Headers = {
  "x-hasura-admin-secret": `${process.env.REACT_APP_HASURA_SECRET}`,
};
export const Uri = `${process.env.REACT_APP_HASURA_URL}`
// export const FileUploadUrl = "https://ec2-54-237-59-75.compute-1.amazonaws.com:3001/fileUpload"